import { render } from "./CampaignTableItem.vue?vue&type=template&id=758dd3db&scoped=true"
import script from "./CampaignTableItem.vue?vue&type=script&lang=js"
export * from "./CampaignTableItem.vue?vue&type=script&lang=js"

import "./CampaignTableItem.vue?vue&type=style&index=0&id=758dd3db&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-758dd3db"]])

export default __exports__